import { Component, OnInit } from '@angular/core';
import { TabViewModule } from 'primeng/tabview';
import { SettingsService } from '../shared/services/settings.service';
import { EmailSmsTemplateDataModel } from '../shared/models/email-sms-template-data-model';
import { ConfigurationService } from '@admin/shared/services/configuration.service';

@Component({
  selector: 'hr-email-sms-templates-list',
  templateUrl: './email-sms-templates-list.component.html',
  styleUrls: ['./email-sms-templates-list.component.less'],
  standalone: false,
})
export class EmailSmsTemplatesListComponent implements OnInit {
  public emailSmsTemplates: EmailSmsTemplateDataModel;
  public tabIndex: number;

  constructor(
    private settingsService: SettingsService,
    private config: ConfigurationService
  ) {}

  ngOnInit() {
    let config = this.config.getCachedConfig();
    this.loadTemplatesData();
  }

  public loadTemplatesData() {
    this.settingsService.LoadTemplatesData().subscribe((data) => {
      this.emailSmsTemplates = data;
    });
  }
}
